import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { BreakpointProvider } from './BreakpointContext';
import getBreakpoint from '../getBreakpoint';

/**
 * @typedef {Object} CopytextProps
 * @property {React.ReactNode} [children]
 * @returns {React.ReactElement}
 */
const BreakpointDetector = ({ children }) => {
  const [breakpoint, setBreakpoint] = useState('lg');

  const resizeHandler = debounce(() => {
    setBreakpoint(getBreakpoint());
  }, 250);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    resizeHandler();

    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  return <BreakpointProvider value={breakpoint}>{children}</BreakpointProvider>;
};

export default BreakpointDetector;
